import Http from 'services/Http';
import sanitizeAgenticBody from './sanitizeAgenticBody';

class AgentMetricApi {
  list() {
    return Http.get('/v1/agent-metrics').then(r => r.data.metrics);
  }

  create(body) {
    return Http.post('/v1/agent-metrics', sanitizeAgenticBody(body)).then(r => r.data.metric);
  }

  update(id, body) {
    return Http.put(`/v1/agent-metrics/${id}`, sanitizeAgenticBody(body)).then(r => r.data.metric);
  }

  evaluate(id, body) {
    return Http.post(`/v1/agent-metrics/${id}/evaluate`, body).then(r => r.data.result);
  }

  reevaluate(id, body = {}) {
    return Http.post(`/v1/agent-metrics/${id}/reevaluate`, body).then(r => r.data.result);
  }

  destroy(id) {
    return Http.delete(`/v1/agent-metrics/${id}`);
  }
}

export default new AgentMetricApi();
